import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/15/principle/principle-2-airborne.svg`,
        },
      },
      styles: {
        padding: "5%",
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/03/15/principle/principle-2-airborne.wav`,
      theme: "secondary",
      icon: "cis-volume-high",
      text: "Play",
      shape: "round",
    },
  },
];
